import * as A from "../../node_modules/.pnpm/three@0.172.0/node_modules/three/build/three.tsl.js";
import { transformColor as t } from "../../utilities/transformations.js";
import { distort as I } from "../../helpers/distort.js";
import { grain as O } from "../../helpers/grain.js";
import { getAspectCorrectedCoordinates as D } from "../../utilities/uv.js";
const q = {
  name: "Synthesis9",
  collection: "synthesis",
  tags: ["wave", "gradient"],
  props: {
    colorA: {
      type: String,
      default: "#150e7e",
      transform: t,
      description: "The left color of the first wave"
    },
    colorB: {
      type: String,
      default: "#9f4e83",
      transform: t,
      description: "The right color of the first wave"
    },
    colorC: {
      type: String,
      default: "#c6b873",
      transform: t,
      description: "The left color of the second wave"
    },
    colorD: {
      type: String,
      default: "rgba(69,78,131,0.53)",
      transform: t,
      description: "The right color of the second wave"
    },
    backgroundColor: {
      type: String,
      default: "#0a1029",
      transform: t,
      description: "The background color"
    },
    frequency: {
      type: Number,
      default: 1,
      description: "The frequency of the waves"
    },
    speed: {
      type: Number,
      default: 1,
      description: "The speed of the waves"
    },
    amplitude: {
      type: Number,
      default: 0.07,
      description: "The amplitude of the waves"
    },
    smoothness: {
      type: Number,
      default: 0.2,
      description: "How soft the edges of the waves are"
    }
  },
  fragmentNode: (e) => {
    const {
      vec4: p,
      uv: h,
      time: n,
      sin: s,
      mix: r,
      abs: a,
      smoothstep: c,
      add: d
    } = A, i = 0.05, l = 0.03, m = 1.5, g = 4, _ = -0.01, o = I(h(), 0.08, 1, 34), y = s(
      o.x.mul(e.frequency.uniform).mul(Math.PI * 2).add(n.mul(e.speed.uniform))
    ).mul(e.amplitude.uniform).add(0.5).sub(i), T = s(
      o.x.mul(e.frequency.uniform).mul(Math.PI * 2).add(n.mul(e.speed.uniform).add(g))
    ).mul(e.amplitude.uniform).add(0.5).sub(i).add(_), b = r(
      e.colorA.uniform,
      e.colorB.uniform,
      o.x
    ), E = r(
      e.colorC.uniform,
      e.colorD.uniform,
      o.x
    ), v = a(o.y.sub(y)).add(o.y.mul(l)), S = a(o.y.sub(T)).add(o.y.mul(l)), u = c(
      e.smoothness.uniform,
      0,
      v
    ), f = c(
      e.smoothness.uniform,
      0,
      S
    ), { correctedUV: w } = D(), C = O(0.8)(w), N = d(
      b.mul(u),
      E.mul(f)
    ).mul(m).sub(C.mul(m));
    return p(
      r(
        e.backgroundColor.uniform,
        N,
        d(u, f).min(1)
      ),
      1
    );
  }
};
export {
  q as componentDefinition,
  q as default
};
